var _linearGradient, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGlp40(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 39.998,
    viewBox: "0 0 39.998 39.998",
    width: 39.998,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    x1: 0.8,
    x2: 0.225,
    y1: 0.087,
    y2: 0.91
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03d1cf",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e09f8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21344.178 753.068-.312-.6h5.238l.129.182a15.411 15.411 0 0 0 28.1-9.9l-9.352-.016 2.73 7.722-3.344 4.594-5.994-17.011 19.732.038.086.3a17.689 17.689 0 0 1 .525 2.286 19.371 19.371 0 0 1 .279 3.343 20.023 20.023 0 0 1 -16.656 19.71 21.7 21.7 0 0 1 -3.393.279 19.886 19.886 0 0 1 -17.768-10.927zm3.363-3.193h-4.684l-.08-.3a17.768 17.768 0 0 1 -.494-2.254 20.006 20.006 0 0 1 37.525-12.45l.311.6h-5.27l-.129-.182a15.422 15.422 0 0 0 -28.107 9.9l9.391.016-2.73-7.722 3.359-4.594 5.977 17.011z",
    fill: "url(#a)",
    transform: "translate(-21342 -724.001)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGlp40);
export default __webpack_public_path__ + "static/media/ic_glp_40.087335c1de3c0e1ab4c2ccd60921e7df.svg";
export { ForwardRef as ReactComponent };